import React from 'react';
// Awards sales Follow up
const EighteenStepWhatsappTemplate = ({ values }) => {
  const {
    client_name,
    conference_short_name,
    registration_link,
    deadline_date,
    your_name,
    contact_details,
  } = values;

  return (
    <div>
      <p>
        <strong>Dear {client_name ? client_name : `[Client Name]`},</strong>
      </p>
      <p>
        <strong>
          {conference_short_name
            ? conference_short_name
            : `[Conference Short Name]`}
        </strong>{' '}
        is offering prestigious awards to recognize your research:
      </p>

      <p>
        <ul>
          <li>
            <strong>🏆 Best Paper Award </strong>– Honoring exceptional research
            quality and originality.
          </li>

          <li>
            <strong>🎤 Best Paper Presentation Award</strong> – For the most
            impactful research presentation.
          </li>
          <li>
            <strong>🎓 Research Excellence Awards</strong> – Recognizing
            outstanding contributions from universities, students, and faculty.
          </li>
        </ul>
      </p>

      <p>
        Don’t miss the chance to gain recognition for your work! Submit your
        paper by {deadline_date ? deadline_date : `[Submission Deadline]`} and
        register now:{' '}
        {registration_link ? (
          <a href={registration_link} target="_blank" rel="noopener noreferrer">
            {registration_link}
          </a>
        ) : (
          ` [Registration Link]`
        )}
        .
      </p>

      <div>
        <strong>Best regards,</strong>
      </div>
      <div>{your_name ? your_name : '[Your Name]'}</div>
      <div>{contact_details ? contact_details : '[Contact details]'}</div>
    </div>
  );
};

export default EighteenStepWhatsappTemplate;
